import "./Biblical.module.css";
import BrandNavigationHeader from "@/reusable_sections/Header";
import BiblicalNameDirectory from "./sections/BiblicalNameDirectory";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function BiblicalPage() {
  return <div>
      <BrandNavigationHeader />
      <BiblicalNameDirectory />
      <CompanyDirectory />
    </div>;
}